import { render, staticRenderFns } from "./FormControlRegister.vue?vue&type=template&id=8c24a228"
import script from "./FormControlRegister.vue?vue&type=script&lang=js"
export * from "./FormControlRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports